import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { API_CARTE_COLLECTIONNEUR_RETRAIT_PDF } from 'constants/apiUrls.constants';
import { ButtonGroup } from '@si-armes/dsfr-react';
import BoutonFichierTelechargeable from 'components/Commun/Fichier/BoutonFichierTelechargeable';
import { MIME_APPLICATION_OCTET_STREAM, MIME_APPLICATION_PDF } from 'constants/fileConstant';
import axios from 'axios';

const CarteCollectionneurRetraitTelechargementBouton = ({ numero }) => {
    const [base64TelechargementCarteCollectionneur, setBase64TelechargementCarteCollectionneur] =
        useState({
            data: null,
            isLoading: false,
        });

    const genererPdfRetraitCarteCollectionneur = () => {
        setBase64TelechargementCarteCollectionneur({
            ...base64TelechargementCarteCollectionneur,
            isLoading: true,
        });
        axios
            .get(process.env.REACT_APP_API_DETENTEURS_URL + API_CARTE_COLLECTIONNEUR_RETRAIT_PDF)
            .then((payload) =>
                setBase64TelechargementCarteCollectionneur({
                    data: payload.data.data,
                    isLoading: false,
                }),
            )
            .catch(() =>
                setBase64TelechargementCarteCollectionneur({
                    ...base64TelechargementCarteCollectionneur,
                    isLoading: false,
                }),
            );
    };

    return (
        <ButtonGroup inline>
            <BoutonFichierTelechargeable
                handleOnClick={genererPdfRetraitCarteCollectionneur}
                label="Télécharger le retrait de ma carte de collectionneur"
                isLoading={base64TelechargementCarteCollectionneur.isLoading}
                titreFichier={`retrait-carte-collectionneur-${numero}.pdf`}
                mimeType={MIME_APPLICATION_PDF || MIME_APPLICATION_OCTET_STREAM}
                contenu={base64TelechargementCarteCollectionneur.data}
                iconOnly
                title="Télécharger le retrait de ma carte de collectionneur"
            />
        </ButtonGroup>
    );
};

CarteCollectionneurRetraitTelechargementBouton.propTypes = {
    numero: PropTypes.string.isRequired,
};

export default CarteCollectionneurRetraitTelechargementBouton;
